import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import '../sass/static_home.scss';
import {
  homePath,
  isExternalLink,
  staticEventImage,
  staticEventLink,
  staticHomeImage
} from '../../api/staticHome';

const StaticHomeCard = (
  { link, image, alt, reload = false }: { link: string, image: string, alt: string, reload?: boolean }
) => {
  const content: ReactNode = image ? <img src={image} alt={alt} /> : null;

  // reload fuerza una navegacion completa del browser en vez de la del router.
  if (reload || isExternalLink(link)) {
    return <a href={link} className='static-home-card'>{content}</a>;
  }
  return <Link to={link} className='static-home-card'>{content}</Link>;
};

const StaticHome = () => {
  return (
    <div className='static-home'>
      <Container fluid className='static-home-body'>
        <Row className='h-100'>
          <Col xs={12} className='static-home-col'>
            <StaticHomeCard link={staticEventLink} image={staticEventImage} alt='Ir al evento' reload />
          </Col>
          <Col xs={12} className='static-home-col'>
            <StaticHomeCard link={homePath} image={staticHomeImage} alt='Ir a Entradaweb' />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StaticHome;
